import React from 'react';
import { ToolbarButton, Icon } from 'react-onsenui';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './ToolbarRightMenuButton.css';
import { ActionSheet } from 'antd-mobile';

const ToolbarRightMenuButton = props => {

    const showActionSheet = () => {
        const BUTTONS = [..._.values(_.mapValues(props.settings, setting => <span style={styles.action_sheets}>{setting.name}</span>)), <span style={styles.action_sheets}>ANNULER</span>];
        ActionSheet.showActionSheetWithOptions({
          options: BUTTONS,
          cancelButtonIndex: BUTTONS.length - 1,
          destructiveButtonIndex: BUTTONS.length - 1,
          maskClosable: true,
          'data-seed': 'logId'
        },
        (k) => {
            const setting = props.settings[k];
            if(setting && setting.to) {
                props.history.push(setting.to);
            }
            else if(setting && setting.onClick) {
                setting.onClick();
            }
        });
      }

    return (
        <ToolbarButton onClick={showActionSheet}>
            <Icon size={25} icon='md-more' />
        </ToolbarButton>
    )
}

const styles = {
    action_sheets: {
        fontFamily: 'fff-equipe', 
        fontSize: '15px', 
        color: '#004586', 
        fontWeight: 700,
    }
}

ToolbarRightMenuButton.propTypes = {
    settings: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        to: PropTypes.string,
        name: PropTypes.string
    })).isRequired
}

export default withRouter(ToolbarRightMenuButton);